import { Container, CvLink, GithubImg, LinkedinImg, ProfileFormation, ProfileImg, ProfileInfo, ProfileLinks, ProfileName } from "./CardPlayerElements"

type CardPlayerProps = {
    name: string;
    formation: string;
    img: string;
    githubLink?: string;
    linkedinLink?: string;
    cvLink?: string;
}

export default function CardPlayer(props: CardPlayerProps) {

    return (
        <Container key={props.name}>
            <ProfileImg src={props.img}></ProfileImg>
            <ProfileInfo>
                <ProfileName>{props.name}</ProfileName>
                <ProfileFormation>{props.formation}</ProfileFormation>
                <ProfileLinks>
                    {props.githubLink ? <GithubImg href={props.githubLink} target="_blank"><img src="./images/github.png" alt="" /></GithubImg> : <></>}
                    {props.linkedinLink ? <LinkedinImg href={props.linkedinLink} target="_blank"><img src="./images/linkedin.png" alt="" /></LinkedinImg> : <></>}
                    {props.cvLink ? <CvLink href={props.cvLink} target="_blank"><img src="./images/curriculum.png" alt="" /></CvLink> : <></>}
                </ProfileLinks>
            </ProfileInfo>
        </Container>
    )

}